import React, { useState, useContext, useEffect } from "react";
import { MDBTabsContent, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { useNavigate } from 'react-router-dom';
import CardLayout from "../CommonLayout/CardLayout";
import LoginForm from "./LoginForm";
import ForgotPasswordModal from "../PasswordChanges/ForgotPasswordModal";
import { UserContext } from '../../../Context/UserContext';
import InstallPWAAndroid from '../../../PWA/InstallPWAAndroid';
import InstallIosPrompt from '../../../PWA/InstallIosPrompt';
import constants from "../../../config/constants";
import { useLocation } from 'react-router-dom';
import useAxiosCall from '../../../Hooks/useAxiosCall';
import { SecureStorage } from '../../../Utilities/StorageEncryption';
import { assignPostAutoLoginLocation } from '../../../Utilities/safePostAutoLoginPath';
import { setHelmet } from '../../../Common/useHelmet';
import seo from '../../../Common/seo.json';

/** Reads first query param whose name matches (case-insensitive), e.g. qJwt, QJWT, page, PAGE */
function getSearchParamCaseInsensitive(searchParams, name) {
  const target = name.toLowerCase();
  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === target) {
      return value;
    }
  }
  return null;
}

const Login = () => {
  const { signIn } = useContext(UserContext);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { makeApiCall } = useAxiosCall();
  useEffect(() => {
    // localStorage.clear();
  }, []);
  const handleForgotPasswordClick = () => {
    navigate('/forgot-password');
  };
  useEffect(() => {
    localStorage.removeItem('tokenKey');
    localStorage.removeItem('refreshToken');
    // Parse the query parameters
    const queryParams = new URLSearchParams(location.search);
    const qJwt = getSearchParamCaseInsensitive(queryParams, 'qJwt');
    const page = getSearchParamCaseInsensitive(queryParams, 'page');
    if (qJwt != undefined) {
      autoLogin(qJwt, page);
    }
  }, []);

  const autoLogin = async (qJwt, page) => {
    try {
      const requestData = {
        qJwt: qJwt
      };

      await makeApiCall({
        requestData,
        onSuccess: (data) => handleApiCallSuccess(data, page),
        onError: handleApiCallError,
        requestType: 'POST',
        url: 'autoLogin',
      });
    } catch (error) {
      console.error('API call error:', error);
    }
  }
  const handleApiCallSuccess = (data, page) => {
    const userData = {
      name: data.data.name,
      givenName: data.data.givenName,
      surname: data.data.surname,
      emailaddress: data.data.emailaddress,
      preferredName: data.data.preferredName,
      accountType: data.data.accountType,
    };
    signIn(userData);
    const tokenData = {
      value: data.data.token,
      timestamp: new Date().getTime(),
    };
    SecureStorage.setItem('tokenKey', JSON.stringify(tokenData));
    SecureStorage.setItem('refreshToken', data.data.refreshToken)
    
    assignPostAutoLoginLocation(page, process.env.PUBLIC_URL);
  };

  const handleApiCallError = (errorMessage) => {
    // setAlert({ type: 'error', message: errorMessage });
  };

  const handleCloseForgotPasswordModal = () => {
    setForgotPasswordModal(false);
  };

  const handleLogin = (data) => {
    const loginUsername = (data.loginUsername || '').trim().toLowerCase();
    const userData = {
      ...(loginUsername ? { username: loginUsername } : {}),
      name: data.data.name,
      givenName: data.data.givenName,
      surname: data.data.surname,
      emailaddress: data.data.emailaddress,
      preferredName: data.data.preferredName,
      accountType: data.data.accountType,
    };
    signIn(userData);
    const tokenData = {
      value: data.data.token,
      timestamp: new Date().getTime(),
    };
    SecureStorage.setItem('tokenKey', JSON.stringify(tokenData));
    SecureStorage.setItem('refreshToken', data.data.refreshToken)
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    window.location.assign(`${base}/portal/home`);
  };
  return (
    <>
    {process.env.REACT_APP_PWA_ENABLE == 1 && <InstallPWAAndroid />}
    {process.env.REACT_APP_PWA_ENABLE == 1 && <InstallIosPrompt />}
    {setHelmet(seo.parents.login.title)}
    <CardLayout title="Welcome to PropertyBoss Online">
      <MDBTabsContent className="mt-4">
        <LoginForm onSubmit={(userData) => handleLogin(userData)} />
        <div className="mt-3">
          <MDBRow>
            <MDBCol size="6" className="md-6">
              <p className="text-left">For Client Care, please call 864-297-7661 x2</p>
            </MDBCol>
            <MDBCol size="6" className="md-6">
              <span className="text-primary cursor-pointer text-right" onClick={handleForgotPasswordClick}>
                Forgot Password?
              </span>
            </MDBCol>
          </MDBRow>
        </div>
        {forgotPasswordModal && (
          <ForgotPasswordModal isOpen onClose={handleCloseForgotPasswordModal} />
        )}
      </MDBTabsContent>
    </CardLayout>
    </>
  );
};

export default Login;
